import React from 'react';
import { DetailsListView, EntityGridListProps } from '../../Common/DetailsList/DetailListView';
import { t } from 'i18next';
import { CategoriaIconFormat, RamaIconFormat } from '../../Common/GridListIconFormat';
export const PlanillaPartidoProgramadoGridList = (props: EntityGridListProps) => {
  const formatRama = (item: any) => {
    if (item.rama === 'M') {
      return <span>Masculina</span>;
    }
    if (item.rama === 'F') {
      return <span>Femenina</span>;
    }
  };



  const columns = [
    {
      fieldName: 'fecha_hora_juego',
      name: t('Fecha'),
      minWidth: 120,
      maxWidth: 120,
    },
    {
      fieldName: 'club_local',
      name: t('Local'),
      minWidth: 150,
      maxWidth: 150,
    },
    {
      fieldName: 'club_visitante',
      name: t('Visitante'),
      minWidth: 150,
      maxWidth: 150,
    },
    {
      fieldName: 'torneo_nombre',
      name: t('Torneo'),
      minWidth: 150,
      maxWidth: 150,
    },
    {
      fieldName: 'categoria',
        name: 'Cat.',
        minWidth: 40,
        maxWidth: 40,
        _onRender: (item: any) => CategoriaIconFormat(item.categoria),
    },
    {
      fieldName: 'rama',
        name: t('Rama'),
        minWidth: 60,
        maxWidth: 60,
        _onRender: (item: any) => RamaIconFormat(item.rama),
    },
    {
      fieldName: 'division',
      name: t('División'),
      minWidth: 150,
      maxWidth: 150,
    },
  ];
  return (
    <>
      <DetailsListView
        keyList={props.keyList}
        onClickCardMode={() => props.onClickCardMode()}
        onClickGridMode={() => props.onClickGridMode()}
        mode={props.mode}
        title={t(`Partidos programados`)}
        onItemClick={props.onItemClick}
        cols={columns}
        isGridList={true}
        listFilters={[]}
        quickFilters={props.quickFilters}
        baseUrl={props.baseUrl}
        changeBlockUI={props.changeBlockUI}
        courier={props.courier}
      ></DetailsListView>
    </>
  );
};
